import styled from '@emotion/styled';

export const SearchInputBox = styled.div`
	position: relative;
	width: 100%;
	max-width: 33.5rem;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	overflow: hidden;
	border-radius: ${(props) => props.theme.borderRadius.control};
`;
export const IconWrapper = styled.div`
	position: absolute;
	left: 16px;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
	svg {
		width: 24px;
		height: 24px;
		color: #757575;
	}
`;
export const SearchInput = styled.input`
	width: 100%;
	height: 100%;
	min-height: 4.4rem;
	padding: 0 12px 0 48px;
	background-color: white;
	border: 1px solid #adb5bd;
	border-radius: ${(props) => props.theme.borderRadius.control};
	color: #333333;
	font-size: 16px;
	line-height: 1.5;
	transition: all 0.2s ease;
	&::placeholder {
		color: #9e9e9e;
	}
	&:focus {
		outline: none;
		border-color: ${(props) => props.theme.colors.primary400};
		box-shadow: 0 0 0 2px rgba(140, 107, 255, 0.1);
		border-radius: ${(props) => props.theme.borderRadius.control};
	}
`;
